import { request, buildQueryString } from './request';

export const shopApi = {
  getCustomers: (params) => request(`/api/customers${buildQueryString(params)}`),
  getCustomer: (id) => request(`/api/customers/${id}`),
  createCustomer: (data) => request('/api/customers', { method: 'POST', body: JSON.stringify(data) }),
  updateCustomer: (id, data) => request(`/api/customers/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteCustomer: (id) => request(`/api/customers/${id}`, { method: 'DELETE' }),
  resetCustomerPassword: (id) => request(`/api/customers/${id}/reset-password`, { method: 'POST' }),
  approveCustomerReset: (id) => request(`/api/customers/${id}/approve-reset`, { method: 'POST' }),
  sendCustomerActivation: (id) => request(`/api/customers/${id}/send-activation`, { method: 'POST' }),
  sendCustomerLogin: (id, password) => request(`/api/customers/${id}/send-login`, { method: 'POST', body: JSON.stringify({ password }) }),

  getShopOrders: (params) => request(`/api/shop/orders${buildQueryString(params)}`),
  getShopOrder: (id) => request(`/api/shop/orders/${id}`),
  createShopOrder: (data) => request('/api/shop/orders', { method: 'POST', body: JSON.stringify(data) }),
  updateShopOrder: (id, data) => request(`/api/shop/orders/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  assignShopOrder: (id, rider_id) => request(`/api/shop/orders/${id}/assign`, { method: 'POST', body: JSON.stringify({ rider_id }) }),
  updateShopStatus: (id, status, note) => request(`/api/shop/orders/${id}/status`, { method: 'POST', body: JSON.stringify({ status, note }) }),
  restoreShopOrder: (id, note) => request(`/api/shop/orders/${id}/restore`, { method: 'POST', body: JSON.stringify({ note }) }),
  archiveShopOrder: (id) => request(`/api/shop/orders/${id}/archive`, { method: 'POST' }),
  unarchiveShopOrder: (id) => request(`/api/shop/orders/${id}/unarchive`, { method: 'POST' }),
  getShopWhatsapp: (id, text) => request(`/api/shop/orders/${id}/whatsapp${buildQueryString({ text })}`),
  createShopAccessLink: (id) => request(`/api/shop/orders/${id}/access-link`, { method: 'POST' }),

  getShopSettings: () => request('/api/shop/settings'),
  updateShopSettings: (data) => request('/api/shop/settings', { method: 'PATCH', body: JSON.stringify(data) }),

  getInvoice: (orderId) => request(`/api/shop/orders/${orderId}/invoice`),
  saveInvoice: (orderId, data) => request(`/api/shop/orders/${orderId}/invoice`, { method: 'PUT', body: JSON.stringify(data) }),
  removeInvoiceItem: (orderId, data) => request(`/api/shop/orders/${orderId}/invoice/remove-item`, {
    method: 'POST',
    body: JSON.stringify(data || {}),
  }),
  issueInvoice: (orderId) => request(`/api/shop/orders/${orderId}/invoice/issue`, { method: 'POST' }),
  confirmInvoice: (orderId) => request(`/api/shop/orders/${orderId}/invoice/confirm`, { method: 'POST' }),
  unlockInvoice: (orderId, data) => request(`/api/shop/orders/${orderId}/invoice/unlock`, { method: 'POST', body: JSON.stringify(data || {}) }),
  collectPayment: (orderId, amount) => request(`/api/shop/orders/${orderId}/collect`, { method: 'POST', body: JSON.stringify({ amount }) }),

  getInbox: (params) => request(`/api/shop/inbox${buildQueryString(params)}`),
  getOrderConversations: (orderId) => request(`/api/shop/orders/${orderId}/conversations`),
  getConversationMessages: (id) => request(`/api/shop/conversations/${id}/messages`),
  sendConversationMessage: (id, data) => request(`/api/shop/conversations/${id}/messages`, { method: 'POST', body: JSON.stringify(data) }),
  approveMessage: (id, text) => request(`/api/shop/messages/${id}/approve`, { method: 'POST', body: JSON.stringify({ text }) }),
  forwardWhatsapp: (id) => request(`/api/shop/messages/${id}/forward-whatsapp`, { method: 'POST' }),

  getRidersFinanceOverview: () => request('/api/shop/finance/overview'),
  getRiderFinance: (id) => request(`/api/shop/riders/${id}/finance`),
  updateRiderFinance: (id, data) => request(`/api/shop/riders/${id}/finance`, { method: 'PATCH', body: JSON.stringify(data) }),
  depositRiderFloat: (id, data) => request(`/api/shop/riders/${id}/finance/deposit`, { method: 'POST', body: JSON.stringify(data) }),
  adjustRiderFloat: (id, data) => request(`/api/shop/riders/${id}/finance/adjust`, { method: 'POST', body: JSON.stringify(data) }),
  repayRiderFloat: (id, data) => request(`/api/shop/riders/${id}/finance/repay`, { method: 'POST', body: JSON.stringify(data) }),
  getSettlementPreview: (id, params) => request(`/api/shop/riders/${id}/settlement-preview${buildQueryString(params)}`),
  closeShopSettlement: (id, data) => request(`/api/shop/riders/${id}/settlement`, { method: 'POST', body: JSON.stringify(data) }),
  getShopSettlements: (params) => request(`/api/shop/settlements${buildQueryString(params)}`),
  getShopSettlement: (id) => request(`/api/shop/settlements/${id}`),

  getPublicInvoice: (token) => request(`/api/public/invoices/${token}`),
  activatePublicInvoiceAccount: (token, data) => request(`/api/public/invoices/${token}/activate`, {
    method: 'POST',
    body: JSON.stringify(data || {}),
  }),
  loginPublicInvoiceAccount: (token, data) => request(`/api/public/invoices/${token}/login`, {
    method: 'POST',
    body: JSON.stringify(data || {}),
  }),
  requestPublicInvoiceReset: (token, data) => request(`/api/public/invoices/${token}/request-reset`, {
    method: 'POST',
    body: JSON.stringify(data || {}),
  }),
  requestCustomerPasswordReset: (data) => request('/api/customer/request-password-reset', {
    method: 'POST',
    body: JSON.stringify(data || {}),
  }),
  getPublicOrder: (token) => request(`/api/public/orders/${token}`),
  getPublicMessages: (token) => request(`/api/public/orders/${token}/messages`),
  sendPublicMessage: (token, text) => request(`/api/public/orders/${token}/messages`, { method: 'POST', body: JSON.stringify({ text }) }),

  registerCustomer: (data) => request('/api/customer/register', { method: 'POST', body: JSON.stringify(data) }),
  getCustomerMe: () => request('/api/customer/me'),
  changeCustomerPassword: (data) => request('/api/customer/change-password', { method: 'POST', body: JSON.stringify(data) }),
  getMyOrders: () => request('/api/customer/orders'),
  getMyOrder: (id) => request(`/api/customer/orders/${id}`),
  getMyChats: () => request('/api/customer/chats'),
  startMyChat: (data) => request('/api/customer/chats', {
    method: 'POST',
    body: JSON.stringify(typeof data === 'string' ? { text: data } : (data || {})),
  }),
  getMyChatMessages: (id) => request(`/api/customer/chats/${id}/messages`),
  sendMyChatMessage: (id, text) => request(`/api/customer/chats/${id}/messages`, { method: 'POST', body: JSON.stringify({ text }) }),
  saveMyOrderItems: (orderId, items) => request(`/api/customer/orders/${orderId}/items`, {
    method: 'PUT',
    body: JSON.stringify({ items }),
  }),
  confirmOrderFromChat: (id, data) => request(`/api/shop/orders/${id}/confirm-from-chat`, { method: 'POST', body: JSON.stringify(data || {}) }),
};
